module.exports = "data:image/svg+xml,module.exports = __webpack_public_path__ + 'fonts/jd-logo92d78bbac05d53a8ab76921ab1fba46c.svg';"